<template>
  <v-layout>
    <v-flex xs12 sm12 md12 lg10 offset-lg1>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12 sm4>
            <v-select
              v-bind:items="items"
              item-text="name"
              item-value="id"
              v-model="itemId"
              label="Selecciona item"
              autocomplete
              required
            >
              <template slot="selection" slot-scope="data">{{ $t('ITEM'+data.item.id+'.SHORTTITLE', version) }}</template>
              <template slot="item" slot-scope="data">
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ $t('ITEM'+data.item.id+'.SHORTTITLE', version) }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t('info.scopes.SCOPE'+data.item.scope+'.TITLE', version) }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-select>
          </v-flex>
          <v-flex sm5 offset-sm1 v-if="itemId !== null">
            <p>Item: {{ $t('ITEM'+itemId+'.TITLE', version) }}</p>
            <p>Dimensió: {{ $t('info.scopes.SCOPE'+scopeId+'.TITLE', version) }}</p></v-flex>
          <v-flex xs12 sm10 offset-sm1>
            <bar-chart :chart-data="dataObject" :options="optionsObject" :width="400" :height="200"></bar-chart>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
    <v-btn fab large bottom left fixed class="warning" v-on:click="$router.push({ name: 'Home' })"><v-icon>arrow_back</v-icon></v-btn>
    <loading v-model="loading" :message="$t('common.LOADING')"></loading>
  </v-layout>
</template>

<script>
  import {StatisticsResource} from '@/api/statistics'
  import LineChart from './LineChart'
  import ScatterChart from './ScatterChart'
  import {ItemResource} from '../../api/item'
  import Loading from '@/components/common/Loading'
  import BarChart from './BarChart'
  import moment from 'moment'
  export default {
    name: 'itemEvolution',
    components: {
      BarChart,
      Loading,
      'line-chart': LineChart,
      'scatter-chart': ScatterChart,
      'bar-chart': BarChart
    },
    data () {
      return {
        items: [],
        itemId: null,
        scopeId: null,
        itemStatistics: [],
        dataObject: null,
        loadingContent: false,
        optionsObject: {
          tooltips: {
            callbacks: {
              footer: function (tooltipItems, data) {
                var teachers = data.datasets[tooltipItems[0].datasetIndex].info[tooltipItems[0].index]
                var info = []
                teachers.forEach(t => {
                  let date = moment(new Date(t.questionnaireDate)).format('DD-MM-YYYY')
                  info.push(date + ', ' + t.nom)
                })
                return info
              }
            }
          },
          scales: {
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Intent de autoavaluació'
              }
            }],
            yAxes: [{
              stacked: true,
              ticks: {
                min: 0,
                stepSize: 1
              },
              scaleLabel: {
                display: true,
                labelString: 'Vegades contestat'
              }
            }]
          }
        },
        xAxesLabels: [],
        teachersLoaded: false,
        loading: false,
        version: this.$auth.user().version
      }
    },
    watch: {
      'itemId': function () {
        this.loading = true
        StatisticsResource().getItemStatistics({id: this.itemId}).then(
          response => {
            this.itemStatistics = response.body
            this.updateChart()
            this.loading = false
            console.log(response.body)
          },
          response => {
            console.log('error in items endpoint')
          }
        )
        var item = this.getScopeByItemId(this.itemId)
        this.scopeId = item.scope
      }
    },
    mounted () {
      ItemResource().get().then(
        response => {
          this.items = response.data
        },
        response => {
          console.log('error in items endpoint')
        }
      )
      let axe = {
        stacked: true,
        ticks: {
          min: 0,
          stepSize: 1
        }
      }
      this.$set(this.optionsObject.scales.yAxes, 0, axe)
    },
    created () {
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(String(value)).format('DD/MM/YYYY')
        }
      }
    },
    methods: {
      toggleStack: function () {
        /* console.log('toooooogle')
        let axe =
        this.$set(this.optionsObject.scales.yAxes, 0, axe)
        // this.optionsObject.scales.yAxes[0].stacked = !this.optionsObject.scales.yAxes[0].stacked
        this.updateChart() */
      },
      getScopeByItemId: function (itemId) {
        return this._.find(this.items, function (i) {
          return i.id === itemId
        })
      },
      updateChart: function () {
        var redData = []
        var orangeData = []
        var greenData = []
        var redInfo = []
        var orangeInfo = []
        var greenInfo = []
        var labels = []

        this.itemStatistics.forEach(is => {
          labels.push(is.order)
          redData.push(is.red)
          orangeData.push(is.orange)
          greenData.push(is.green)
          redInfo.push(is.redInfo)
          orangeInfo.push(is.orangeInfo)
          greenInfo.push(is.greenInfo)
        })

        var stack = 1
        var redDataset = {
          label: 'red',
          data: redData,
          backgroundColor: '#f44336',
          borderColor: '#cd261e',
          stack: stack,
          borderWidth: 2,
          info: redInfo
        }

        if (!this.optionsObject.scales.yAxes[0].stacked) stack++
        // console.log(stack)
        var orangeDataset = {
          label: 'orange',
          data: orangeData,
          backgroundColor: '#ff9800',
          borderColor: '#cd4300',
          stack: stack,
          borderWidth: 2,
          info: orangeInfo
        }

        if (!this.optionsObject.scales.yAxes[0].stacked) stack++
        var greenDataset = {
          label: 'green',
          data: greenData,
          backgroundColor: '#46cd46',
          borderColor: '#4caf50',
          stack: stack,
          borderWidth: 2,
          info: greenInfo
        }

        this.dataObject = {
          labels: labels,
          datasets: [redDataset, orangeDataset, greenDataset]
        }
        console.log(redDataset)
        console.log(orangeDataset)
        console.log(greenDataset)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/results/ItemEvolution.vue